/*
 * Glitter burst (his 3 Nov: „jak się zapełnia produktem, to takie lekkie jakby piksele czy kreseczki idą na boki, jakby pękała
 * bańka albo zaklęcie ktoś rzucił … z tych brokatowych pikseli jak nasz pasek postępu”). A short spray of the set bar's squares
 * (3 px, the same gold, a few brand pink) from one point, mostly sideways, slowing down and fading out. One fixed canvas over the
 * page, shown only while something flies and cleared when done; it never takes part in the layout or catches a tap. Nothing at all
 * with reduced motion.
 *
 * SBBurst.at(x, y, { scale }) — viewport point; scale 1 for a new cart line, smaller for a place in the set card.
 * Two strengths for him to compare (his pick pending): `soft` (default) and `strong`; `?sb_burst=strong` in the address keeps the
 * other one for this browser tab.
 */
(() => {
  if (window.SBBurst) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const LEVELS = {
    soft: { n: 16, dist: 28, life: 560 },
    strong: { n: 30, dist: 46, life: 700 },
  };
  let level = 'soft';
  try {
    const q = new URLSearchParams(window.location.search).get('sb_burst');
    if (q && LEVELS[q]) sessionStorage.setItem('sb-burst', q);
    const kept = sessionStorage.getItem('sb-burst');
    if (kept && LEVELS[kept]) level = kept;
  } catch (e) {}

  let canvas = null;
  let ctx = null;
  let dpr = 1;
  let raf = 0;
  let parts = [];

  function ensure() {
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.setAttribute('aria-hidden', 'true');
      canvas.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483002;display:none';
      document.body.appendChild(canvas);
      ctx = canvas.getContext('2d');
    }
    dpr = Math.min(2, window.devicePixelRatio || 1);
    const w = Math.round(window.innerWidth * dpr);
    const h = Math.round(window.innerHeight * dpr);
    if (canvas.width !== w || canvas.height !== h) {
      canvas.width = w;
      canvas.height = h;
    }
    canvas.style.display = 'block';
  }

  // the bar's colours: gold squares of varied light, and about one in five brand pink
  function colour() {
    const hue = Math.random();
    if (Math.random() < 0.2) return `hsl(${(352 + hue * 14) % 360} ${74 + 10 * hue}% ${70 + Math.random() * 16}%)`;
    return `hsl(${34 + hue * 12} ${66 + 14 * Math.random()}% ${44 + Math.random() * 40}%)`;
  }

  function at(x, y, opts = {}) {
    if (reduce.matches || !document.body) return;
    const L = LEVELS[opts.level] || LEVELS[level];
    const scale = opts.scale || 1;
    ensure();
    const t0 = performance.now();
    const n = Math.max(6, Math.round(L.n * scale));
    for (let i = 0; i < n; i += 1) {
      // mostly to the sides, a little up and down: a bubble bursting along the card
      const side = Math.random() < 0.5 ? 0 : Math.PI;
      const a = side + (Math.random() - 0.5) * 1.5;
      const d = L.dist * scale * (0.45 + Math.random() * 0.75);
      parts.push({
        x,
        y,
        dx: Math.cos(a) * d,
        dy: Math.sin(a) * d * 0.7,
        t0: t0 + Math.random() * 60,
        life: L.life * (0.75 + Math.random() * 0.4),
        c: colour(),
        s: Math.random() < 0.25 ? 2 : 3,
      });
    }
    if (!raf) raf = requestAnimationFrame(frame);
  }

  function frame(t) {
    raf = 0;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    parts = parts.filter((p) => t - p.t0 < p.life);
    parts.forEach((p) => {
      const k = Math.max(0, (t - p.t0) / p.life);
      const e = 1 - Math.pow(1 - k, 3); // fast out, slowing down
      const px = p.x + p.dx * e;
      const py = p.y + p.dy * e + 6 * k * k; // a touch of fall at the end
      ctx.globalAlpha = Math.max(0, 1 - k * k);
      ctx.fillStyle = p.c;
      const s = p.s * dpr;
      ctx.fillRect(Math.round(px * dpr), Math.round(py * dpr), s, s);
    });
    ctx.globalAlpha = 1;
    if (parts.length) raf = requestAnimationFrame(frame);
    else {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      canvas.style.display = 'none';
    }
  }

  // from an element: its centre, where the picture lands
  function on(el, opts) {
    if (!el) return;
    const r = el.getBoundingClientRect();
    if (r.bottom < 0 || r.top > window.innerHeight || !r.width) return;
    at(r.left + r.width / 2, r.top + r.height / 2, opts);
  }

  window.SBBurst = { at, on, levels: Object.keys(LEVELS), get level() { return level; } };
})();
